import React, { useState, useEffect, useRef } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Aurora from '../../components/Aurora/Aurora';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import './TermsOfCondition.css';

const TermsOfCondition = () => {
    const [navbarHidden, setNavbarHidden] = useState(false);
    const lastScrollY = useRef(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const viewportHeight = window.innerHeight;

            if (currentScrollY > lastScrollY.current && currentScrollY > viewportHeight) {
                setNavbarHidden(true);
            } else {
                setNavbarHidden(false);
            }
            lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="terms-page">
            <Navbar className={navbarHidden ? 'hidden' : ''} />

            {/* Aurora header */}
            <div className="terms-aurora hero-section">
                <div className="aurora-wrapper">
                    <Aurora
                        colorStops={["#0088FF", "#4ecdc4", "#1E40AF"]}
                        blend={0.8}
                        amplitude={1.2}
                        speed={0.3}
                    />
                </div>
            </div>

            <div className="terms-content">
                <div className="terms-container">
                    <header className="terms-header">
                        <h1 className="section-title">Terms and Conditions</h1>
                        <p className="subtitle">Effective Date: January 1, 2026</p>
                    </header>

                    <div className="terms-card">
                        <section className="terms-section">
                            <h2>1. Introduction</h2>
                            <p>Welcome to My Digital Schools ("Company", "we", "our", "us"). These Terms and Conditions ("Terms", "Terms of Service") govern your use of our web application located at mydigitalschools.com (together or individually "Service") operated by My Digital Schools.</p>
                            <p>Our Privacy Policy also governs your use of our Service and explains how we collect, safeguard and disclose information that results from your use of our web pages.</p>
                        </section>

                        <section className="terms-section">
                            <h2>2. Communications</h2>
                            <p>By using our Service, you agree to subscribe to newsletters, marketing or promotional materials and other information we may send. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or by emailing at support@mydigitalschools.com.</p>
                        </section>

                        <section className="terms-section">
                            <h2>3. Accounts</h2>
                            <p>When you create an account with us, you guarantee that you are above the age of 18, and that the information you provide us is accurate, complete, and current at all times. Inaccurate, incomplete, or obsolete information may result in the immediate termination of your account on the Service.</p>
                        </section>

                        <section className="terms-section">
                            <h2>4. Educational Content & SSO</h2>
                            <p>Our Service provides access to third-party educational content providers via Single Sign-On (SSO). We are not responsible for the content, privacy policies, or practices of any third-party educational provider. You acknowledge and agree that your access to such content is subject to the terms of service of those providers.</p>
                            <p>School administrators are responsible for managing access permissions for their students and staff.</p>
                        </section>

                        <section className="terms-section">
                            <h2>5. Prohibited Uses</h2>
                            <p>You may use Service only for lawful purposes and in accordance with Terms. You agree not to use Service:</p>
                            <ul>
                                <li>In any way that violates any applicable national or international law or regulation.</li>
                                <li>For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way by exposing them to inappropriate content or otherwise.</li>
                                <li>To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail", "chain letter," "spam," or any other similar solicitation.</li>
                            </ul>
                        </section>

                        <section className="terms-section">
                            <h2>6. Termination</h2>
                            <p>We may terminate or suspend your account and bar access to Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of Terms.</p>
                        </section>

                        <section className="terms-section">
                            <h2>7. Changes to Terms</h2>
                            <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. What constitutes a material change will be determined at our sole discretion.</p>
                        </section>

                        <section className="terms-section">
                            <h2>8. Contact Us</h2>
                            <p>If you have any questions about these Terms, please contact us at support@mydigitalschools.com.</p>
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
            <ScrollToTop />
        </div>
    );
};

export default TermsOfCondition;
